import { render } from "./SitzungDetailsTagesordnungItemEdit.pug?vue&type=template&id=c48e28a4&lang=pug"
import script from "./SitzungDetailsTagesordnungItemEdit.js?vue&type=script&lang=js"
export * from "./SitzungDetailsTagesordnungItemEdit.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__